{
  "": "",
  "account_configured": "Je account is ingesteld",
  "activity_log": "Activiteitenlog",
  "administrator": "beheerder",
  "and": "en",
  "area_designation": "gebiedsaanduiding",
  "back_to_overview": "Terug naar overzicht",
  "cancel": "Annuleren",
  "close_message": "Melding sluiten",
  "close_modal": "Venster sluiten",
  "complete": "Afronden",
  "contains_error": "bevat een fout",
  "contains_warning": "bevat een waarschuwing",
  "continue": "Verder",
  "coordinator_csb": "coördinator CSB",
  "coordinator_gsb": "coördinator GSB",
  "counted_number": "Geteld aantal",
  "counting_method": "stemopneming",
  "counting_method_type": "Type stemopneming",
  "CSO": "Centrale stemopneming",
  "date_locale": "nl-NL",
  "delete": "Verwijderen",
  "description": "Omschrijving",
  "digital_signature": "Digitale vingerafdruk",
  "documents_are_invalidated": "De eerder gemaakte documenten van deze zitting zijn daardoor niet meer geldig. Maak een nieuw proces-verbaal door de invoerfase opnieuw af te ronden.",
  "do_not_save": "Niet bewaren",
  "DSO": "Decentrale stemopneming",
  "election_definition": "Verkiezingsdefinitie",
  "empty": "leeg",
  "error_code": "Foutcode",
  "field": "Veld",
  "file_too_large": "Het bestand <strong>{filename}</strong> is te groot. Kies een bestand van maximaal {max_size} Megabyte.",
  "finished": "Afgerond",
  "for_your_information": "Ter info",
  "general": "Algemeen",
  "general_details": "Algemene gegevens",
  "generate_new_results": "Maak een nieuw proces-verbaal voor deze zitting",
  "GSB": "Gemeentelijk stembureau",
  "hashcode": "hashcode",
  "history_back": "Terug naar de vorige pagina",
  "imported": "Geïmporteerd",
  "invalid_paste_content": "Je probeert <strong>{value}</strong> te plakken. Je kunt hier alleen cijfers invullen.",
  "list": "Lijst",
  "lists": "Lijsten",
  "list_name": "Lijstnaam",
  "loading": "Laden...",
  "logs": "Logs",
  "mandatory_question": "Deze vraag is verplicht",
  "manual_input": "Handmatig invullen",
  "import_from_file": "Importeren uit een bestand",
  "menu": "Menu",
  "minutes": "{minutes} minuten",
  "name": "Naam",
  "next": "Volgende",
  "no": "Nee",
  "no_file_chosen": "Geen bestand gekozen",
  "no_polling_stations_found": "Geen stembureaus gevonden",
  "not_yet_finished": "nog niet afgerond",
  "number": "Nummer",
  "number_of_voters": "Aantal kiesgerechtigden",
  "one_minute": "1 minuut",
  "one_second": "1 seconde",
  "optional": "Optioneel",
  "or": "of",
  "overview": "Overzicht",
  "page_number": "Pagina {page} van de {totalPages}",
  "pay_attention": "Let op",
  "previous": "Vorige",
  "progress": "Voortgang",
  "role": "Rol",
  "save": "Opslaan",
  "save_changes": "Wijzigingen opslaan",
  "saved": "opgeslagen",
  "seconds": "{seconds} seconden",
  "select_file": "Bestand kiezen",
  "server": "Server",
  "something_goes_wrong": "Er gaat iets fout",
  "something_went_wrong": "Sorry, er ging iets mis",
  "stack_trace": "Foutmelding",
  "start": "Beginnen",
  "success": "Gelukt!",
  "test": "test",
  "to_check": "Te controleren",
  "today": "vandaag",
  "total": "Totaal",
  "totals_list": "Totaal lijst {group_number}",
  "type": "Soort",
  "typist": "Invoerder",
  "typist_csb": "invoerder CSB",
  "typist_gsb": "invoerder GSB",
  "user": "Gebruiker",
  "version": "versie",
  "view_progress": "Bekijk voortgang",
  "voters": "kiesgerechtigden",
  "vote_count": "Aantal stemmen",
  "yes": "Ja",
  "yesterday": "gisteren",
  "you_are_here": "je bent hier"
}
